export const NINA_MEMORY_SCHEMA_VERSION = 1;
export const NINA_MEMORY_STORAGE_KEY = "anina:nina-memory:v1";

export const NINA_MEMORY_CATEGORIES = [
  "academy-progress",
  "simulated-trade",
  "trade-plan-decision",
  "mistake",
  "lesson-learned",
  "nina-observation",
  "user-approved-rule",
];

export const NINA_EVIDENCE_STATUSES = [
  "verified",
  "simulated",
  "user-reported",
  "system-derived",
  "hypothesis",
];

export const NINA_RISK_LEVELS = [
  "none",
  "low",
  "medium",
  "high",
  "critical",
];

export const NINA_RECORD_STATUSES = ["active", "archived"];

export const createEmptyMemoryEnvelope = (timestamp = new Date().toISOString()) => ({
  schemaVersion: NINA_MEMORY_SCHEMA_VERSION,
  createdAt: timestamp,
  updatedAt: timestamp,
  records: [],
});

